<template>
  <div id="contenedor-agregar-nueva-licitacion">
    <custom-button
      v-if="mixValidaScopesActions(1)"
      :onlyIcon="onlyIcon"
      @click="mostrarDialogo = true"
      :label="onlyIcon ? '' : 'Nueva'"
      iconText="mdi-plus"
      tipo="agregar">
    </custom-button>
    <v-dialog
      v-model="mostrarDialogo"
      width="80%">
      <v-form
        v-model="formularioValido"
        ref="agregarNuevaLicitacion">
        <v-card>
          <v-card-title class="secondary--text">
            Agregar nueva licitación
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <custom-select
                cols="12"
                md="4"
                v-model.number="licitacion.tipo"
                label="Tipo de licitacion"
                :items="tiposLicitacion"
                item-text="text"
                item-value="id"
                clearable
                :rules="[mixReglas.requerido]">
              </custom-select>
              <custom-text-field
                cols="12"
                md="4"
                v-model="licitacion.numero"
                label="Número de Licitación"
                :rules="[mixReglas.requerido]">
              </custom-text-field>
              <custom-select
                cols="12"
                md="4"
                v-model.number="licitacion.caracter"
                label="Caracter"
                :items="tiposCaracter"
                item-text="text"
                item-value="id"
                :rules="[mixReglas.requerido]">
              </custom-select>
              <custom-text-area
                cols="12"
                md="12"
                v-model="licitacion.objeto"
                label="Objeto"
                :rules="[mixReglas.requerido]"
                auto-grow
                required>
              </custom-text-area>
              <custom-select
                cols="12"
                md="4"
                v-model.number="licitacion.normatividad"
                label="Normatividad"
                :items="tiposNormatividad"
                item-text="text"
                item-value="id"
                :rules="[mixReglas.requerido]">
              </custom-select>
              <custom-text-field
                cols="12"
                md="4"
                v-model="licitacion.numeroConvocatoria"
                label="Número de Convocatoria"
                :rules="[mixReglas.requerido]">
              </custom-text-field>
              <custom-date-picker
                cols="12"
                md="4"
                v-model="licitacion.fechaConvocatoria"
                label="Fecha de la Convocatoria"
                :rules="[mixReglas.requerido]">
              </custom-date-picker>
            </v-row>
            <v-row align="center" justify="start">
                <custom-date-picker
                  cols="12"
                  md="4"
                  v-model="licitacion.fechaInicio"
                  label="Fecha de Inicio"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
                <custom-date-picker
                  cols="12"
                  md="4"
                  v-model="licitacion.fechaTermino"
                  label="Fecha de Termino"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
                <v-col cols="12" lg="auto">
                  <span>
                    <b class="secondary--text">{{ licitacion.plazo }}</b>
                    <b class="base6--text"> días</b>
                  </span>
                </v-col>
                <custom-text-field
                  cols="12"
                  md="4"
                  v-model.number="licitacion.anticipoMaterial"
                  label="Anticipo Material"
                  type="number"
                  suffix="%">
                </custom-text-field>
                <custom-text-field
                  cols="12"
                  md="4"
                  v-model.number="licitacion.anticipoInicio"
                  label="Anticipo Inicio"
                  type="number"
                  suffix="%">
                </custom-text-field>
                <v-col cols="12" lg="auto">
                  <span>
                    <b class="secondary--text">{{ totalPorcentajeAnticipos }}</b>
                    <b class="base6--text"> % Anticipo Total</b>
                  </span>
                </v-col>
                <v-col cols="12">
                  <SelectObrasListasAdjudicar v-model="licitacion.obras">
                  </SelectObrasListasAdjudicar>
                </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixAgregarLicitacion"
              tipo="formAceptar"
              label="Guardar"
              :disabled="!formularioValido || enviandoFormulario">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
// import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import SelectObrasListasAdjudicar from '@/components/ObrasListasAdjudicar.vue';
import mixLicitaciones from './mixLicitaciones';

export default {
  name: 'AgregarNuevaLicitacion',
  mixins: [mixLicitaciones],
  components: {
    CustomTextField,
    CustomButton,
    // CustomAutocomplete,
    CustomTextArea,
    CustomSelect,
    CustomDatePicker,
    SelectObrasListasAdjudicar,
  },
  props: {
    onlyIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarDialogo: false,
      formularioValido: false,
      enviandoFormulario: false,
      totalPorcentajeAnticipos: 0,
      licitacion: {
        tipo: 0,
        numero: '',
        caracter: 1,
        normatividad: 0,
        objeto: '',
        numeroConvocatoria: '',
        fechaConvocatoria: '',
        fechaInicio: '',
        fechaTermino: '',
        plazo: 0,
        anticipoMaterial: 0,
        anticipoInicio: 0,
        obras: [],
      },
      tiposLicitacion: [
        { id: 1, text: 'LICITACIÓN PÚBLICA' },
        { id: 2, text: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
      ],
      tiposCaracter: [
        { id: 1, text: 'NACIONAL' },
        { id: 2, text: 'ESTATAL' },
      ],
      tiposNormatividad: [
        { id: 1, text: 'FEDERAL' },
        { id: 2, text: 'ESTATAL' },
      ],
    };
  },
  methods: {
    obrasSeleccionadas(ids) {
      this.licitacion.obras = ids;
    },
    limpiarFormulario() {
      this.$refs.agregarNuevaLicitacion.reset();
      this.licitacion.plazo = 0;
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
      this.mostrarDialogo = false;
    },
    setPlazo() {
      const { fechaInicio, fechaTermino } = this.licitacion;
      if (!fechaInicio || !fechaTermino) return;
      const a = this.$moment(fechaInicio);
      const b = this.$moment(fechaTermino);
      this.licitacion.plazo = Number(b.diff(a, 'days')) + 1;
    },
    setPorcentaje() {
      const { anticipoMaterial, anticipoInicio } = this.licitacion;
      this.totalPorcentajeAnticipos = anticipoMaterial + anticipoInicio;
    },
  },
  computed: {
    fechaInicio() {
      return this.licitacion.fechaInicio;
    },
    fechaTermino() {
      return this.licitacion.fechaTermino;
    },
    anticipoInicio() {
      return this.licitacion.anticipoInicio;
    },
    anticipoMaterial() {
      return this.licitacion.anticipoMaterial;
    },
  },
  watch: {
    fechaInicio() {
      this.setPlazo();
    },
    fechaTermino() {
      this.setPlazo();
    },
    anticipoInicio() {
      this.setPorcentaje();
    },
    anticipoMaterial() {
      this.setPorcentaje();
    },
  },
};
</script>

<style>

</style>
